import { BaseContainerModel } from '../../base-container.model';
import {bl_fi_consolidated_arap_login_subject_link_RowClass} from '../../../dbschema';

export class ConsolidatedArapLoginSubjectLinkContainerModel extends BaseContainerModel {
  bl_fi_consolidated_arap_login_subject_link: bl_fi_consolidated_arap_login_subject_link_RowClass = new bl_fi_consolidated_arap_login_subject_link_RowClass();
}
